<template>
  <div>
    <q-layout
      view="lHh lpr lFf"
      container
      style="height: 100vh"
      class="shadow-2"
    >
      <div :key="updateKey" class="column items-center q-mt-xl">
        <div v-for="(name, key) in tabs" :key="key">
          <q-page-container v-if="tab === name.tab" :key="updateKey">
            <q-page class="q-pa-sm q-mr-md q-ml-md" :key="updateKey">
              <q-table
                :title="t('resources.title')"
                :rows="name"
                :columns="columns"
                :filter="filter"
                :no-data-label="t('resources.no-data-found')"
                :no-results-label="t('no-result')"
                row-key="id"
                class="frosted"
                :key="key"
              >
                <template v-slot:body-cell-download="props">
                  <q-td key="download" :props="props">
                    <q-btn
                      dense
                      flat
                      color="green-10"
                      icon="mdi-download"
                      :label="t('resources.download')"
                      @click="Download(props.row)"
                    ></q-btn>
                  </q-td>
                </template>
                <template v-slot:top-right>
                  <q-input
                    dense
                    debounce="300"
                    v-model="filter"
                    :placeholder="t('resources.search')"
                  >
                    <template v-slot:append>
                      <q-icon name="search" />
                    </template>
                  </q-input>
                </template>

                <template v-slot:no-data="{ icon, message, filter }">
                  <div
                    class="full-width row flex-center text-accent q-gutter-sm"
                  >
                    <q-icon size="2em" name="sentiment_dissatisfied" />
                    <span>{{ t("resources.error") }} {{ message }}</span>
                    <q-icon
                      size="2em"
                      :name="filter ? 'filter_b_and_w' : icon"
                    />
                  </div>
                </template>
              </q-table>
            </q-page>
          </q-page-container>
        </div>
        <div
          class="frosted q-pa-md q-mt-xl column justify-center"
          style="width: 70%"
        >
          <div class="text-h6 q-pb-md">Resurse</div>
          <q-list bordered class="rounded-borders">
            <q-expansion-item
              expand-separator
              icon="mdi-group"
              label="Metodologie SCI-TB">
              <q-card>
                <q-card-section>
                  <q-btn label="Acceseaza Fisierul" color="primary" @click="OpenInNewTab(DWlink)">

                  </q-btn>
                </q-card-section>
              </q-card>
            </q-expansion-item>
            <q-expansion-item
              expand-separator
              icon="mdi-ear-hearing-off"
              label="Aparate Auditive compensate prin decizie C.A.S."
            >
              <q-card>
                <q-card-section>
                  <div class="q-ml-md text-p">
                    Casele de Asigurări de Sănătate oferă ajutor persoanelor cu
                    deficiențe de auz prin eliberarea unei decizii de
                    compensare, în cuantum de 1058,77 lei.
                    <br /><br /><b
                      >Persoanele adulte cu pierderi auditive beneficiază de
                      acest suport o dată la cinci ani.</b
                    >
                  </div>
                </q-card-section>
                <q-card-section class="q-ml-md">
                  <div class="text-p text-bold text-blue-9">
                    Cum obțin decizia de compensare a Casei de Asigurări de
                    Sănătate?
                  </div>
                  <div>
                    <ol>
                      <li>
                        I. Mă prezint la medicul ORL cu bilet de trimitere de la
                        medicul de familie
                      </li>
                      <li>
                        II. După consult, medicul ORL îmi va cere să fac
                        audiograma vocală și tonală
                      </li>
                      <li>
                        III. Medicul va interpreta audiograma și va stabili dacă
                        este necesar aparatul auditiv. Dacă am nevoie de aparat
                        auditiv , medicul va întocmi scrisoarea de recomandare
                        către Casa de Asigurări de Sănătate
                      </li>
                      <li>
                        IV. În a patra etapă, voi depune dosarul la Casa de
                        Asigurări de Sănătate pentru a obține decizia de
                        compensare
                      </li>
                    </ol>
                  </div>
                </q-card-section>
                <q-card-section class="q-ml-md">
                  <div class="text-p text-bold text-blue-9">
                    Ce documente sunt necesare?
                  </div>
                  <div class="text-p">
                    Documentele necesare în dosar pentru a obține decizia de
                    compensare sunt:
                  </div>
                  <div>
                    <ol>
                      <li>
                        1. Cererea tip de procurare a dispozitivelor medicale
                      </li>
                      <li>
                        2. Recomandare tip (scrisoare medicală) eliberată de
                        medicul O.R.L. în baza audiogramei (este valabilă 30 de
                        zile de la data emiterii);
                      </li>
                      <li>
                        3. Audiograma tonală şi vocală ( original și xerocopie)
                      </li>
                      <li>
                        <ol>
                          <li>
                            4. a) 2 xerocopii buletin sau carte de identitate
                          </li>
                          <li class="q-pl-md">
                            b) Xerocopie după certificatul de naștere, pentru
                            copiii sub 14 ani
                          </li>
                          <li class="q-pl-md">
                            c) Xerocopie după buletin/cartea de identitate a
                            unuia dintre membrii familiei (părinte, soţ/soţie,
                            fiu/fiică) / a împuternicitului legal / a
                            reprezentantului legal al asiguratului
                          </li>
                        </ol>
                      </li>
                      <li>
                        5. Dovada calității de asigurat, după caz: ultimul cupon
                        de pensie (copie sau originalul), adeverință de
                        salariat, adeverință de elev/student ptr. categoria
                        vârstă peste 18 ani, adeverința de somaj, adeverința de
                        ajutor social, certificat de încadrare într-un grad de
                        handicap.
                      </li>
                    </ol>
                  </div>
                </q-card-section>
                <q-card-section class="q-ml-md">
                  <div class="text-p text-bold text-blue-9">
                    Cât timp este valabilă decizia de compensare?
                  </div>
                  <div class="text-p">
                    Decizia de compensare este valabilă 30 de zile de la data
                    emiterii.
                  </div>
                </q-card-section>
                <q-card-section class="q-ml-md">
                  <div class="text-p text-bold text-blue-9">
                    Cum verific calitatea de asigurat?
                  </div>
                  <div class="text-p">
                    Pot verifica calitatea de asigurat la adresa:
                    <a
                      href="http://cas.cnas.ro/page/verificare-asigurat.html"
                      class="text-blue-10"
                      >Verificare asigurat (cnas.ro)</a
                    >
                  </div>
                </q-card-section>
              </q-card>
            </q-expansion-item>
            <q-expansion-item
              expand-separator
              icon="mdi-scale-balance"
              label="Drepturile pacienților cu tuberculoză"
            >
              <q-expansion-item
                :header-inset-level="1"
                header-class="text-red"
                expand-separator
                icon="mdi-hospital"
                label="Dreptul la îngrijiri medicale și tratament gratuit"
              >
                <q-card>
                  <q-card-section>
                    -În România, persoanele adulte și copiii diagnosticațe cu
                    tuberculoză primesc spitalizarea, tratamentul și
                    consultațiile de control gratuit.
                    <br />
                    -Pacienții diagnosticați cu tuberculoză au dreptul la
                    asigurare fără să aibă obligația de a plăti contribuția la
                    asigurările sociale de sănătate.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-worker"
                header-class="text-blue-10"
                label="Dreptul la concediu şi indemnizaţie pentru incapacitate temporară de muncă 100%"
              >
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cine beneficiază de concediu medical?"
                >
                  <q-card>
                    <q-card-section>
                      Dacă la momentul înbolnăvirii eram angajat sau în șomaj,
                      am dreptul la concediu medical. <br />
                      <br />De asemenea, am dreptul la concediu medical dacă la
                      momentul îmbolnăvirii eram persoană autorizată care
                      desfășoară activități independente, aveam încheiat un
                      contract de asigurări sociale pentru concedii și
                      indemnizații, eram administrator sau manager care a
                      încheiat un contract de administrare sau de management sau
                      eram membrul unei asociații familiale
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum obțin concediul medical?"
                >
                  <q-card>
                    <q-card-section>
                      Pe perioada internarii, primesc certicatul de concediu
                      medical in fiecare lună, de la spital. După externare, în
                      fiecare lună, medicul pneumolog din dispensar îmi va da
                      certificatul de concediu medical pe care îl depun la
                      angajator sau la șomaj.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Care este durata concediului medical?"
                >
                  <q-card>
                    <q-card-section>
                      Voi fi în concediu medical pe toată perioada de tratament,
                      până la vindecare.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum primesc banii pe concediu medical?"
                >
                  <q-card>
                    <q-card-section
                      >Pe card sau in contul de salariu. În luna în curs voi
                      primi banii pentru luna anterioară (ex: în luna martie voi
                      primi indemnizația pentru luna februarie)
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Câți bani primesc?"
                >
                  <q-card>
                    <q-card-section>
                      Concediu medical este 100% din salariu.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Pot să fiu concediat pe perioada concediului medical?"
                >
                  <q-card>
                    <q-card-section>
                      În perioada concediului medical nu pot fi concediat.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-food-apple"
                header-class="text-green"
                label="Dreptul la Indemnizatia lunară de hrană"
              >
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cine beneficiază?"
                >
                  <q-card>
                    <q-card-section>
                      Persoanele adulte și copiii diagnosticate cu tuberculoză
                      care nu sunt internate în spital.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum obțin indemnizația lunară de hrană?"
                >
                  <q-card>
                    <q-card-section
                      >Cum obțin indemnizația lunară de hrană?
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Care sunt condițiile de acordare?"
                >
                  <q-card>
                    <q-card-section
                      >Să urmez tratamentul așa cum a spus medicul. Dacă omit 3
                      doze din tratamentul lunar, nu mai primesc indemnizatia
                      lunară de hrană.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Pe ce perioadă se acordă indemnizația lunară de hrană?"
                >
                  <q-card>
                    <q-card-section>
                      - Primesc indemnizația lunară de hrană până când sunt
                      declarat vindecat de către medicul curant.
                      <br />
                      - În cazul abandonului tratamentului sau al decesului
                      pacientului, indemnizația nu se mai plătește.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum primesc indemnizația lunară de hrană?"
                >
                  <q-card>
                    <q-card-section>
                      Prin mandat poștal , cont personal sau cont de card
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Când primesc indemnizația lunară de hrană?"
                >
                  <q-card>
                    <q-card-section
                      >Spre sfârșitul lunii în curs, primesc indemnizația pentru
                      luna anterioară (ex: la sfârșitul lunii martie, primesc
                      indemnizația pentru luna februarie)</q-card-section
                    >
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Câți bani primesc?"
                >
                  <q-card>
                    <q-card-section>
                      - Persoanele adulte diagnosticate cu tuberculoză primesc
                      17,6 lei/zi ( ex:luna anterioară a avut 30 de zile. Voi
                      primi la sfârșitul lunii 17,6x30=528 lei) <br />
                      - Copiii diagnosticați cu tuberculoză primesc 16,5lei/zi
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-cash"
                label="Dreptul la pensia de invaliditate"
                header-class="text-purple-8"
              >
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cine beneficiază?"
                >
                  <q-card>
                    <q-card-section
                      >- Persoanele care nu au împlinit vârsta standard de
                      pensionare și care și-au pierdut total sau cel puțin
                      jumătate din capacitatea de muncă și și care au realizat
                      stagiu de cotizare, în condițiile legii.
                      <br />
                      <br />
                      - Persoanele care au satisfăcut serviciul militar ca
                      militari în termen sau militari cu termen redus
                      (indiferent de stagiul de cotizare realizat);
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Care sunt condițiile de acordare?"
                >
                  <q-card>
                    <q-card-section
                      >Pot beneficia de pensie de invaliditate dacă am fost
                      încadrat în grad de invaliditate de către medicul expert
                      al casei teritoriale de muncă, nu am împlinit vârsta de
                      pensionare și mi-am pierdut total sau cel puțin jumătate
                      din capacitatea de muncă și am lucrat cu carte de muncă.
                      Dacă sunt bărbat și am făcut armata, nu am nevoie de
                      stagiu de cotizare.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Care sunt gradele de invaliditate?"
                >
                  <q-card>
                    <q-card-section
                      >Invaliditatea este : <br />
                      - de gradul I -caracterizată de pierderea totală a
                      capacității de muncă și a capacității de autoîngrijire
                      <br />
                      - de gradul II- caracterizată de pierderea totală a
                      capacității de muncă și păstrarea capacității de
                      autoîngrijire
                      <br />
                      - de gradul III- caracterizată de pierderea a cel puțin
                      jumătate din capacitatea de muncă, persoana putând să
                      presteze o activitate profesională corespunzătoare a cel
                      mult jumătate din timpul normal de lucru
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cine face evaluarea pentru încadrarea in grad de invaliditate?"
                >
                  <q-card>
                    <q-card-section
                      >Cabinetul de expertiză medicală a capacităţii de muncă
                      din cadrul casei teritoriale de pensii, în funcție de
                      domiciliu.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Ce acte sunt necesare pentru obținerea certificatului de încadrare în grad de invaliditate?"
                >
                  <q-card>
                    <q-card-section
                      >Pentru încadrarea în grad de invaliditate, am nevoie de
                      următoarele documente: <br />
                      - cerere tip <br />
                      - buletin de identitate sau carte de identitate în copie
                      <br />
                      - certificat de naştere în copie <br />- livretul militar
                      în copie <br />- cartea de muncă sau adeverinte de vechime
                      în muncă în original și copie <br />- referat privind
                      situația medicală prezentă întocmit de medicul pneumolog
                      în original <br />- documente medicale din care să rezulte
                      diagnosticul de tuberculoză si alte afectiuni
                      asociate(dacă există). Ex: bilet de iesire din spital,
                      analize medicale, radiografii, adeverință de la
                      dispensarul TB în copie
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum obțin certificatul de încadrare în grad de invaliditate?"
                >
                  <q-card>
                    <q-card-section
                      >Primul pas este să mă adresez medicului pneumolog pentru
                      a obține referatul medical pentru încadrare în grad de
                      invaliditate. <br />
                      <br />
                      Cererea împreună cu documentele le depun la cabinetul de
                      expertiză medicală a capacităţii de muncă din cadrul casei
                      teritoriale de pensii, în funcție de domiciliu.
                      <br />
                      <br />
                      Decizia medicală de încadrare în grad de invaliditate se
                      emite în 45 de zile și îmi va fi comunicată în 5 zile de
                      la emitere.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum obțin pensia de invaliditate?"
                >
                  <q-card>
                    <q-card-section
                      >După ce am primit decizia medicală, merg la casa
                      teritorială de pensii și depun următoarele acte:
                      <br />
                      - cerere de pensionare <br />
                      - buletin de identitate sau carte de identitate în copie
                      <br />
                      - certificat de naştere în copie <br />
                      - decizia medicală de încadrare în grad de invaliditate în
                      original, emisă de medicul expert al asigurărilor sociale
                      în original
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Cum primesc pensia de boală?"
                >
                  <q-card>
                    <q-card-section>
                      - prin mandat poștal , cont personal sau cont de card
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Când mă prezint la revizuirea medicală?"
                >
                  <q-card>
                    <q-card-section>
                      Termenul de revizuire medicală și documentația de
                      revizuire le găsesc pe decizia de pensionare.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  icon="mdi-minus"
                  label="Pot să primesc pensie de invaliditate, dacă am indemnizație de handicap?"
                >
                  <q-card>
                    <q-card-section>
                      Da, pot primi și pensia de invaliditate și indemnizația de
                      handicap.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
              </q-expansion-item>
            </q-expansion-item>
            <q-expansion-item
              expand-separator
              icon="mdi-book-open"
              label="Obligațiile pacienților cu tuberculoză"
            >
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-pill"
                label="Să urmez tratamentul complet așa cum spune medicul pneumolog ."
              >
                <q-card>
                  <q-card-section>
                    Este foarte important să iau medicamentele atât timp cât
                    spune medicul. Dacă întrerup tratamentul prea devreme, mă
                    pot îmbolnăvi din nou. Ca să îmi protejez familia voi
                    continua tratamentul ca să mă vindec.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-calendar-check"
                label="După externare să mă prezint la controalele medicale medicale stabilite de către medicul curant"
              >
                <q-card>
                  <q-card-section>
                    Mă voi prezenta la control de căte ori stabilește medicul,
                    până la vindecare. Controlul presupune analize de sânge,
                    radiografie și producerea unei probe de spută.
                    <br />
                    Dacă am tuberculoză pot fi chemat la control din două în
                    două luni. <br />
                    Dacă am tuberculoză rezistententă voi merge lunar la
                    control.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-doctor"
                label="Să respect recomandările medicului curant privind izolarea, pentru a împiedica răspândirea bolii în populație"
              >
                <q-card>
                  <q-card-section>
                    Când sufăr de tuberculoză pulmonară sau se bănuiește că
                    sufăr de această boală, de obicei sunt izolat într-un salon
                    de spital până când nu îi mai pot infecta pe alții.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
            </q-expansion-item>
            <q-expansion-item
              expand-separator
              icon="mdi-smoking"
              label="Fumatul și tuberculoza"
            >
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Ca pacient cu tuberculoză, în ce fel mă afectează fumatul?"
              >
                <q-card>
                  <q-card-section>
                    Riscul de te infecta cu tuberculoză este mai mare decât la
                    nefumători. Studiile au arătat o creștere de aproximativ 2
                    ori, în rândul fumătorilor comparativ cu nefumătorii.
                    <br /><br />
                    Fumătorii activi care au început să fumeze din adolescență
                    și care au fumat mai mult de 10 ani, prezintă un risc mai
                    mare de a se infecta cu Tb decât non-fumătorii. Componentele
                    dăunătoare ale fumului de tutun și ale microbilor se
                    acumulează în bronhii, creând zone în care se acumulează,
                    apar inflamații, inclusiv bacili care declanșează
                    tuberculoza.
                    <br /><br />Fumătorii devin deosebit de sensibili la
                    efectele nocive ale poluării atmosferice, ceea ce sporește
                    posibilitatea apariției bronșitei cronice, care predispune
                    la tuberculoză.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="M-am îmbolnăvit de tuberculoză pentru că sunt fumător?"
              >
                <q-card>
                  <q-card-section>
                    Fumătorii sunt mai expuși riscului de a se îmbolnăvi de
                    tuberculoză. <br /><br />
                    Tuberculoza este o boală infecto-contagioasă cauzată de
                    bacilul Koch, însă fumatul afectează plămânii și căile
                    respiratorii și predispune la infectare.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Dacă am încercat să mă las de fumat și nu am reușit până acum, ce pot face?"
              >
                <q-card>
                  <q-card-section>
                    Oamenii sunt diferiți și gradul de dependență este diferit
                    și de aceea unora le este ușor să se lase de fumat, iar
                    altora le este foarte greu și este necesar un efort mai mare
                    și încercări repetate până vor reuși. <br /><br />
                    De asemenea pot primi sprijin de la specialiști prin
                    Programul Stop Fumat
                    <a href="https://stopfumat.eu/" class="text-blue-9"
                      >https://stopfumat.eu/</a
                    >
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Mă ajută să scad numărul de țigări?"
              >
                <q-card>
                  <q-card-section>
                    Este recomandat să opriți fumatul dintr-o data deoarece
                    controlul asupra numărului de țigări prin reducerea lor
                    necesită un efort mult mai mare și în loc să scadă
                    obișnuința, va crește dorința de a fuma și plăcerea
                    fumatului.</q-card-section
                  >
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Cum să fac să mă las de fumat?"
              >
                <q-card>
                  <q-card-section>
                    Un prim pas este să vă clarificați motivele pentru care
                    fumați și pentru care vreți să vă lăsați de fumat, gradul de
                    dependență și ce consecințe apar dacă fumați sau vă lăsați
                    de fumat. Înțelegerea nevoilor din spatele dorinței de a
                    fuma va ajuta să identificați cu ce veți înlocui fumatul
                    când acesta nu va face parte din viața dvs. <br /><br />
                    Puteți apela la ajutor specializat pentru a lămuri aceste
                    lucruri. Puteți beneficia de acest ajutor la
                    <span class="text-green-9 text-bold"
                      >TEL VERDE STOP FUMAT</span
                    >, numărul afișat pe pachetele de țigări
                    <span class="text-bold">0800878673</span>, număr al
                    Programului Stop Fumat
                    <a href="https://stopfumat.eu/" class="text-blue-9"
                      >https://stopfumat.eu/</a
                    >
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Mai pot fuma către o țigară, din când în când?"
              >
                <q-card>
                  <q-card-section>
                    În majoritatea cazurilor, doar o țigară va reactiva
                    receptorii responsabili cu dependența de nicotină și în cel
                    mai scurt timp va crește nevoia de a fuma și veți reveni la
                    numărul de țigări fumate anterior întreruperii fumatului.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Cu ce mă ajută să mă las de fumat?"
              >
                <q-card>
                  <q-card-section>
                    Oprirea fumatului aduce beneficii, indiferent de momentul la
                    care se întâmplă și este cel mai bun lucru pe care îl poți
                    face pentru sănătatea ta. Dintre beneficiile vizibile
                    imediat, amintim: revenirea gustului și mirosului, creșterea
                    capacității de efort, îmbunătățirea respirației, aspectului
                    și a culorii pielii, scăderea riscurilor de îmbolnăvire a
                    multor boli asociate fumatului și nu în ultimul rând, banii
                    rămași în buzunar și creșterea stimei de sine.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
            </q-expansion-item>
            <q-expansion-item
              expand-separator
              icon="mdi-cash-multiple"
              label="Ajutoare financiare oferite prin programul guvernamental Sprijin pentru Romania"
            >
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                icon="mdi-minus"
                label="Ajutor financiar de 700 de lei pentru toti pensionarii"
              >
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  label="1.Când se acordă ajutorul?"
                >
                  <q-card>
                    <q-card-section>
                      Ajutorul de 700 lei se acordă în tranșă unică în luna
                      iulie 2022.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  label="2.	Cine beneficiază de ajutorul de 700 lei?"
                >
                  <q-card>
                    <q-card-section>
                      a) Pensionarii din sistemul public de pensii, ale căror
                      venituri nete lunare proprii sunt mai mici sau egale cu
                      2.000 lei; <br /><br />
                      b) Pensionarii din din sistemul pensiilor militare de
                      stat, ale căror venituri nete lunare proprii sunt mai mici
                      sau egale cu 2.000 lei;
                      <br />
                      <br />
                      c) Pensionarii din Casele de pensii organizate în cadrul
                      sistemelor de asigurări sociale neintegrate sistemului
                      public de pensii;
                      <br />
                      <br />
                      d) Beneficiarii de drepturi prevăzute de legi cu caracter
                      special plătite de casele teritoriale de pensii/casele de
                      pensii sectoriale ale căror venituri lunare sunt mai mici
                      sau egale cu 2.000 de lei;
                      <br />
                      <br />
                      • Ajutorul se acordă doar persoanelor care au domiciliul
                      în România.
                      <br />
                      • Persoanele care au locul de ședere sau reședința în
                      străinătate nu beneficiază de acest ajutor. <br />
                      • În cazul pensionarilor care beneficiază de pensie de
                      urmaș, ajutorul financiar se acordă fiecărui urmaș în
                      parte.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  label="3.Cum primesc ajutorul?"
                >
                  <q-card>
                    <q-card-section>
                      Ajutorul de 700 lei se acordă în tranșă unică în luna
                      iulie 2022.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  label="3.Cum primesc ajutorul?"
                >
                  <q-card>
                    <q-card-section>
                      Ajutorul financiar se plătește, din oficiu, în luna iulie
                      2022, prin casele teritoriale de pensii/casele de pensii
                      sectoriale.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
                <q-expansion-item
                  :header-inset-level="2"
                  expand-separator
                  label="4.Cât timp primesc acest ajutor?"
                >
                  <q-card>
                    <q-card-section>
                      Ajutorul financiar de 700 lei se acordă o singură dată, în
                      luna iulie 2022.
                    </q-card-section>
                  </q-card>
                </q-expansion-item>
              </q-expansion-item>
            </q-expansion-item>
            <q-expansion-item
              expand-separator
              icon="mdi-ticket-outline"
              label="Tichete sociale pentru achizitia de produse alimentare"
            >
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="1.Când începe procesul de acordare a ajutoarelor?"
              >
                <q-card>
                  <q-card-section>
                    La 1 iunie 2022, Ministerul Investițiilor și Proiectelor
                    Europene (MIPE) a început, procesul de emitere, distribuire
                    și încărcare a voucherelor sociale oferite prin programul
                    guvernamental spa
                    <span class="text-bold">„Sprijin pentru România”</span>.
                    Primele carduri au ajuns la beneficiari
                    <span class="text-bold">vineri, 10 iunie 2022</span>.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="2.Cine beneficiază /Care sunt cei 2,5 milioane de beneficiari?"
              >
                <q-card>
                  <q-card-section>
                    a) Pensionarii din sistemul public de pensii, pensionarii
                    aflați în evidența caselor de pensii sectoriale și
                    beneficiarii de drepturi prevăzute de legi cu caracter
                    special, plătite de casele teritoriale de pensii/casele de
                    pensii sectoriale, ale căror venituri nete lunare proprii
                    sunt mai mici sau egale cu 1.500 lei;
                    <br />
                    b) Persoanele încadrate în grad de handicap grav, accentuat
                    sau mediu, ale căror venituri nete lunare proprii sunt mai
                    mici sau egale cu 1.500 lei;
                    <br />
                    c) Familiile cu cel puțin 2 copii în întreținere, ale căror
                    venituri nete lunare pe membru de familie sunt mai mici sau
                    egale cu 600 lei;
                    <br />
                    d) Familiile monoparentale ale căror venituri nete lunare pe
                    membru de familie sunt mai mici sau egale cu 600 lei;
                    <br />
                    e) Familiile care au stabilit dreptul la ajutorul social în
                    condițiile Legii nr. 416/2001 privind venitul minim
                    garantat, cu modificările și completările ulterioare;
                    <br />
                    f) Persoanele fără adăpost, așa cum acestea sunt
                    reglementate potrivit prevederilor legale în vigoare.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="3.	Cum primesc ajutorul?"
              >
                <q-card>
                  <q-card-section>
                    Voucherele vor fi încarcate pe card.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="4.	Cum primesc cardul?"
              >
                <q-card>
                  <q-card-section>
                    Cardul va fi livrat de către Poșta Română numai dacă
                    îndepliniți criteriile de mai sus. Dacă la sfârșitul
                    perioadei de acordare a tranșei I nu intrați în posesia
                    cardului, vă veți adresa oficiului postal de care aparțineți
                    pentru a primi îndrumări.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="4.	Cum primesc cardul?"
              >
                <q-card>
                  <q-card-section>
                    Cardul va fi livrat de către Poșta Română numai dacă
                    îndepliniți criteriile de mai sus. Dacă la sfârșitul
                    perioadei de acordare a tranșei I nu intrați în posesia
                    cardului, vă veți adresa oficiului postal de care aparțineți
                    pentru a primi îndrumări.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="5.	Cât timp primesc acest ajutor?"
              >
                <q-card>
                  <q-card-section>
                    Până la sfârșitul anului, o data la 2 luni, cardul dvs va fi
                    încărcat cu 250 lei
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="6.	Cum și unde se folosește cardul?"
              >
                <q-card>
                  <q-card-section>
                    Cardurile vor fi însoțite de instrucțiuni de folosire,
                    detalii privind magazinele unde puteți utiliza cardul și un
                    număr de telefon pentru cazurile în care întâmpinați
                    probleme.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="7.	Cât timp pot folosi sumele de pe card?"
              >
                <q-card>
                  <q-card-section>
                    Sumele de pe card pot fi folosite timp de 12 luni de la data
                    încărcării lor.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="8.	Când primesc aceste ajutoare?"
              >
                <q-card>
                  <q-card-section>
                    După încheierea procesului de distribuire a cardurilor,
                    ajutoarele din tranșa I vor fi încărcate în perioada
                    <span class="text-bold"> 20.06-24.06.2022</span>.
                    <br />
                    <span class="text-bold"
                      >TRANȘA II: august-septembrie 2022</span
                    >
                    <br />
                    -ajutoarele vor fi încărcate în perioada
                    <span class="text-bold"> 29.08.2022 – 02.09.2022 </span>
                    <br />
                    <span class="text-bold"
                      >TRANȘA III: octombrie-noiembrie 2022</span
                    >
                    <br />
                    - ajutoarele vor fi încărcate în perioada
                    <span class="text-bold">24.10.2022-31.10.2022</span>
                    <br />
                    <span class="text-bold"
                      >TRANȘA IV: decembrie-ianuarie 2023
                    </span>
                    <br />
                    - ajutoarele vor fi încărcate în perioada
                    <span class="text-bold">2.12.2022-16.12.2022</span>
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="9.	Pot retrage bani de pe card?"
              >
                <q-card>
                  <q-card-section>
                    <span class="text-bold">Nu</span> puteti retrage numerar de
                    pe card. Cardul se utilizează numai pentru achiziția de
                    alimente sau mese calde.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="10.	Cum plătesc cu cardul?"
              >
                <q-card>
                  <q-card-section>
                    Cardul permite plăți contactless, adică apropiați cardul de
                    terminalul POS de la casă.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="11.	Pot înstrăina cardul?"
              >
                <q-card>
                  <q-card-section>
                    <span class="text-bold">Nu.</span> Cardurile pot fi folosite
                    doar de către beneficiar. În cazul în care beneficiarul nu
                    se poate deplasa la magazin, atunci poate încredința cardul
                    unei persoane apropiate, numai împreună cu actul de
                    identitate, pentru a utiliza ajutorul.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
              <q-expansion-item
                :header-inset-level="1"
                expand-separator
                label="12.	Cum procedez dacă în următoarele luni voi îndeplini condițiile de acordare a ajutoarelor?"
              >
                <q-card>
                  <q-card-section>
                    Verificările se fac din oficiu și se vor emite noi carduri
                    pentru beneficiarii care vor fi introdusi în program in
                    lunile următoare.
                  </q-card-section>
                </q-card>
              </q-expansion-item>
            </q-expansion-item>
          </q-list>
        </div>
      </div>
    </q-layout>
  </div>
</template>

<script>
import { ref } from "vue";
import { Notify, QSpinnerBox } from "quasar";
import { useI18n } from "vue-i18n";
import firebase from "firebase";
import { store } from "../store/store";

export default {
  name: "Resources",

  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    const database = firebase.database().ref();
    const DWlink = "https://firebasestorage.googleapis.com/v0/b/asptmr-platforma.appspot.com/o/resurse%2FTBC%2FMetodologie_SCI%20TB.pdf?alt=media&token=c827df41-a92d-4407-91a8-d93ae9cfc7d3&_gl=1*7l6ox8*_ga*Mzc2ODk0ODk1LjE2OTcxMDU5MjI.*_ga_CW55HF8NVT*MTY5NzExMTY4Mi4yLjEuMTY5NzExMTkxMC40Ni4wLjA"
    return {
      t,
      database,
      filter: ref(""),
      tab: ref("s1"),
      uploadcard: ref(false),
      tabs: {},
      DWlink,
      columns: [
        {
          name: "name",
          required: true,
          label: t("resources.name-title"),
          align: "center",
          field: (row) => row.name,
          format: (val) => `${val}`,
          sortable: true,
        },
        {
          name: "download",
          label: t("resources.download"),
          field: "",
          sortable: false,
          align: "center",
        },
      ],
      OpenInNewTab(url) {
        window.open(url, "_blank").focus();
      },
      Download(file) {
        firebase
          .storage()
          .ref(`resurse/${file.category}/${file.name}.${file.extension}`)
          .getDownloadURL()
          .then((url) => {
            // `url` is the download URL
            Notify.create({
              spinner: QSpinnerBox,
              message: t("resources.prompts.downloading"),
              timeout: 2000,
              color: "blue-10",
            });
            setTimeout(() => {
              window.open(url);
            }, 3000);
          })
          .catch((error) => {
            // Handle any errors
            switch (error.code) {
              case "storage/object-not-found":
                // File doesn't exist
                Notify.create({
                  icon: "mdi-alert-circle",
                  message: t("resources.prompts.notfound"),
                  timeout: 3000,
                  color: "red-10",
                });
                break;

              case "storage/unauthorized":
                // User doesn't have permission to access the object
                Notify.create({
                  icon: "mdi-cancel",
                  message: t("resources.prompts.noperm"),
                  timeout: 3000,
                  color: "orange-10",
                });
                break;

              case "storage/canceled":
                // User canceled the upload
                Notify.create({
                  icon: "mdi-alert-circle",
                  message: t("resources.prompts.stopped"),
                  timeout: 3000,
                  color: "blue-10",
                });
                break;

              case "storage/unknown":
                // Unknown error occurred, inspect the server response
                Notify.create({
                  icon: "mdi-alert-circle",
                  message: t("resources.prompts.unknown"),
                  timeout: 3000,
                  color: "red-10",
                });
                break;
              default:
                break;
            }
          });
      },
      ReadDatabase() {
        // Read database
        const rows_store = {};
        const reader = this.database
          .child("resurse")
          .once("value", function (snapshot) {
            // console.log(Object.keys(snapshot.val()));
            const categories = snapshot.val();
            for (let category in categories) {
              // console.log(category)
              rows_store[category] = [];
              const current_category = categories[category];
              for (let file in current_category) {
                const tosend = current_category[file];
                tosend.name = file;
                rows_store[category].push(tosend);
              }
            }
          });
        reader.then(() => {
          let count = 0;
          for (let category in rows_store) {
            count++;
            this.updateKey += 1;
            rows_store[category].tab = "s" + count;
          }
          this.tabs = rows_store;
          // console.log("Store", rows_store);
        });
      },
    };
  },

  data() {
    return {
      categories: {},
      updateKey: 0,
      storage: firebase.storage().ref("resurse"),
      isadmin: false,
    };
  },
  methods: {
    CheckAdmin() {
      this.isadmin = store.state.user;
    },
    GetStorageData() {
      this.storage
        .listAll()
        .then((res) => {
          res.prefixes.forEach((folder) => {
            // Folders as categories
            const folder_name = folder._delegate._location.path_;
            const folder_name_processed = folder_name.split("/")[1];
            // console.log(folder_name_processed)
            this.categories[folder_name_processed] = [];
            // List files from folders
            folder
              .listAll()
              .then((file) => {
                file.items.forEach((itemref) => {
                  const file_path = itemref._delegate._location.path_;
                  const file_name = file_path.split("/")[2];
                  // console.log(file_name);
                  this.categories[folder_name_processed].push(file_name);
                  // console.log(this.categories[folder_name])
                });
              })
              .catch((error) => {
                alert(error);
              });
          });
          setTimeout(() => {
            Notify.create({
              icon: "mdi-checkbox-marked",
              message: "Baza de date a fost actualizata cu succes",
              timeout: 2000,
              color: "green-7",
            });
            this.AddToDatabase();
          }, 2000);
          // console.log(this.categories);
        })
        .catch((error) => {
          alert(error);
        });
    },

    AddToDatabase() {
      // Write database
      const object_firebase = {};
      for (let obj in this.categories) {
        const category_name = this.categories[obj];
        if (Object.values(category_name).length > 0) {
          object_firebase[obj] = {};
          for (let j = 0; j < category_name.length; j++) {
            const file_name = category_name[j].split(".")[0];
            const file_extension = category_name[j].split(".")[1];

            object_firebase[obj][file_name] = {
              category: obj,
              extension: file_extension,
            };
          }
        }
      }
      // console.log("Object Firebase", object_firebase);
      this.database.update({ resurse: object_firebase });
    },
  },
  created() {
    this.CheckAdmin();
  },
  beforeCreate() {
    this.ReadDatabase();
  },
};
</script>

<style scoped>
.frosted {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 6.5px solid rgba(255, 255, 255, 0.18);
}
</style>